/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Tek kaynak qubepro-core; yalnız resmî UI senkronuyla dağıtılır.
 */
import type { ReactNode } from 'react';
import { guidedLearningTargetSelector } from './guided-learning.contract';

export interface ModalFormFooterViewProps {
    onCancel: () => void;
    labels: { cancel: string; save: string; saving: string; close: string; edit?: string };
    saving?: boolean;
    submitDisabled?: boolean;
    formId?: string;
    viewOnly?: boolean;
    /** Existing record: leave inspection mode without reopening the form. */
    onEdit?: () => void;
    submitLearningTargetId?: string;
    submitButton?: ReactNode;
    submitType?: 'submit' | 'button';
    /** Editors without a native form may provide the save action directly. */
    onSubmit?: () => void;
}

export function ModalFormFooterView({
    onCancel, labels, saving = false, submitDisabled = false, formId, viewOnly = false, onEdit,
    submitLearningTargetId, submitButton, submitType = 'submit', onSubmit,
}: ModalFormFooterViewProps) {
    const safeTarget = guidedLearningTargetSelector(submitLearningTargetId ?? '') ? submitLearningTargetId?.trim() : undefined;
    return <>
        <button type="button" className="btn-secondary" onClick={onCancel} disabled={saving}>
            {viewOnly ? labels.close : labels.cancel}
        </button>
        {viewOnly && onEdit && <button type="button" className="btn-primary" onClick={onEdit} disabled={saving}>
            {labels.edit ?? 'Edit'}
        </button>}
        {!viewOnly && (submitButton ?? <button type={onSubmit ? 'button' : submitType} className="btn-primary" form={formId} onClick={onSubmit}
            disabled={saving || submitDisabled} data-qp-learning-id={safeTarget}>
            {saving ? labels.saving : labels.save}
        </button>)}
    </>;
}
